// src/App.js
import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Import main components
import Dashboard from './components/Dashboard';
import Clients from './components/Clients';
import Templates from './components/Templates';
import Login from './components/Login';
import Register from './components/Register';
import PrivateRoute from './components/PrivateRoute';

// Import new layout component
import AppLayout from './components/layout/AppLayout';

// Import new Campaign components
import CampaignList from './components/campaign/CampaignList';
import CampaignWizard from './components/campaign/CampaignWizard';

// Import the AuthProvider
import { AuthProvider } from './context/AuthContext';

// Import CSS 
import './styles/global.css';
import './styles/App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          {/* Protected routes with new layout */}
          <Route path="/" element={
            <PrivateRoute>
              <AppLayout />
            </PrivateRoute>
          }>
            {/* Dashboard */}
            <Route index element={<Navigate to="/dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* Client Management */}
            <Route path="clients" element={<Clients />} />
            
            {/* Email Templates */}
            <Route path="templates" element={<Templates />} />
            
            {/* Campaign Management - New Modern System */}
            <Route path="campaigns" element={<CampaignList />} />
            <Route path="campaigns/new" element={<CampaignWizard />} />
            <Route path="campaigns/:id" element={<CampaignWizard edit={true} />} />
            
            {/* Analytics */}
            <Route path="analytics" element={<div>Analytics Dashboard</div>} />
            
            {/* Settings */}
            <Route path="settings" element={<div>Settings</div>} />
            
            {/* Help & Support */}
            <Route path="support" element={<div>Help & Support</div>} />
          </Route>
          
          {/* Catch all redirect to dashboard */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;